import { BaseReq } from "@/core/interface";

export class QuantityRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  contractQuantitiesListId: string = ""; // 合同中工程量清单的ID
  bizNo: string = ""; // 清单编号
  name: string = ""; // 清单名称
  feature: string = ""; // 项目特征
  unit: string = ""; // 结算单位
  count: number = 0; // 当前合同: 工程量
  price: number = 0; // 当前合同: 综合单价
  totalPrice: number = 0; // 当前合同: 合价
  changeCount: number = 0; // 本次变更: 工程量
  changePrice: number = 0; // 本次变更: 综合单价
  changeTotalPrice: number = 0; // 本次变更: 合价
  afterChangeCount: number = 0; // 本次变更后: 工程量
  afterChangePrice: number = 0; // 本次变更后: 综合单价
  afterChangeTotalPrice: number = 0; // 本次变更后: 工程量
  remark: string = ""; // 备注
  id: string = "";
}

// export class QuantityReq extends BaseReq {
//   records: QuantityRecord[] = [];
// }

export class QuantityReq extends BaseReq {
  records: QuantityRecord[] = [];
  current: number = 1;
  size: number = 10;
}

export class QuantityDetailResp {
  records: QuantityRecord[] = [];
}

export class QuantityImportResp {
  records: QuantityRecord[] = [];
}
